var options = []

options.person = [{
    text: 'Title',
    value: 'Entity.Title',
    controlType: 'string',
    type: String,
  },
  {
    text: 'First Name',
    value: 'Entity.FirstName',
    controlType: 'string',
    type: String,
  },
  {
    text: 'Middle Name',
    value: 'Entity.MiddleName',
    controlType: 'string',
    type: String,
  },
  {
    text: 'Last Name',
    value: 'Entity.LastName',
    controlType: 'string',
    type: String,
  },
  {
    text: 'Alternative Last Name',
    value: 'Entity.AlternativeLastName',
    controlType: 'string',
    type: String,
  },
  {
    text: 'Email',
    value: 'Entity.Email',
    controlType: 'string',
    type: String,
  },
  {
    text: 'Alternative Email',
    value: 'Entity.AlternativeEmail',
    controlType: 'string',
    type: String,
  },
  {
    text: 'Mobile Phone',
    value: 'Entity.MobilePhone',
    controlType: 'string',
    type: String,
  },
  {
    text: 'Alternative Phone',
    value: 'Entity.AlternativePhone',
    controlType: 'string',
    type: String,
  },
  {
    text: 'Gender',
    value: 'Entity.GenderType',
    controlType: 'string',
    type: String,
  },
  {
    text: 'Date Of Birth',
    value: 'Entity.DateOfBirth',
    controlType: 'date',
    type: Date,
  },
  {
    text: 'Marital Status',
    value: 'Entity.MaritalStatus',
    controlType: 'string',
    type: String,
  },
  {
    text: 'Address Line 1',
    value: 'Entity.Address.Line1',
    controlType: 'string',
    type: String,
  },
  {
    text: 'Address Line 2',
    value: 'Entity.Address.Line3',
    controlType: 'string',
    type: String,
  },
  {
    text: 'Address City',
    value: 'Entity.Address.City',
    controlType: 'string',
    type: String,
  },
  {
    text: 'Address State',
    value: 'Entity.Address.State',
    controlType: 'string',
    type: String,
  },
  {
    text: 'Address Postal Code',
    value: 'Entity.Address.PostalCode',
    controlType: 'string',
    type: String,
  },
  {
    text: 'Address Country Code',
    value: 'Entity.Address.CountryCode',
    controlType: 'string',
    type: String,
  },
  {
    text: 'Communication Notifications Email',
    value: 'Entity.CommunicationSettings.Notifications.Email',
    controlType: 'boolean',
    type: Boolean,
  },
  {
    text: 'Communication Notifications SMS',
    value: 'Entity.CommunicationSettings.Notifications.Sms',
    controlType: 'boolean',
    type: Boolean,
  },
  {
    text: 'Communication Notifications WhatsApp',
    value: 'Entity.CommunicationSettings.Notifications.WhatsApp',
    controlType: 'boolean',
    type: Boolean,
  },
  {
    text: 'Communication Marketing Email',
    value: 'Entity.CommunicationSettings.Marketing.Email',
    controlType: 'boolean',
    type: Boolean,
  },
  {
    text: 'Communication Marketing SMS',
    value: 'Entity.CommunicationSettings.Marketing.Sms',
    controlType: 'boolean',
    type: Boolean,
  },
  {
    text: 'Communication Marketing WhatsApp',
    value: 'Entity.CommunicationSettings.Marketing.WhatsApp',
    controlType: 'boolean',
    type: Boolean,
  },
  {
    text: 'Properties',
    value: 'Entity.Properties',
    controlType: 'dictionary~object',
    type: String,
  },
  {
    text: 'Protected Properties',
    value: 'Entity.ProtectedProperties',
    controlType: 'protected-properties',
    type: String,
  },
]
options.event = [{
    text: 'Head Counts Expected',
    value: 'Entity.HeadCountsExpected',
    controlType: 'dictionary~number',
    type: Number,
  }, // Number
  {
    text: 'Head Counts Actual',
    value: 'Entity.HeadCountsActual',
    controlType: 'dictionary~number',
    type: Number,
  }, // Number
  {
    text: 'Type',
    value: 'Entity.Type',
    controlType: 'event-type',
    type: String,
  }, // EventType
  {
    text: 'Name',
    value: 'Entity.Name',
    controlType: 'string',
    type: String,
  }, // String
  {
    text: 'Start',
    value: 'Entity.Start',
    controlType: 'date',
    type: Date,
  }, // Date
  {
    text: 'Minutes Duration',
    value: 'Entity.MinutesDuration',
    controlType: 'number',
    type: Number,
  }, // Number
  {
    text: 'Organizer',
    value: 'Entity.OrganizerPersonEntityId',
    controlType: 'person',
    type: String,
  }, // Person Search
  {
    text: 'Event',
    value: 'Entity.EntityId',
    controlType: 'event',
    type: String,
  },
  {
    text: 'Properties',
    value: 'Entity.Properties',
    controlType: 'dictionary~object',
    type: String,
  },
  // Event Selection
  // 'Address',
  // 'Properties',
  // 'Limit',
  // 'BelongsTo',
  // 'BelongsToSeries',
  // 'Integration',
  // 'UniqueCode'
]
options.eventAttendance = [{
    text: 'Event',
    value: 'Entity.EventEntityId',
    controlType: 'event',
    type: String,
  }, // Event Selection
  {
    text: 'Person',
    value: 'Entity.PersonEntityId',
    controlType: 'person',
    type: String,
  }, // Person Search
  {
    text: 'Will Attend',
    value: 'Entity.WillAttend',
    controlType: 'string',
    type: String,
  },
  {
    text: 'Check In',
    value: 'Entity.CheckIn',
    controlType: 'who-when',
    type: Object,
  }, // WhoWhen
  {
    text: 'Check Out',
    value: 'Entity.CheckOut',
    controlType: 'who-when',
    type: Object,
  }, // WhoWhen
  // 'EntityId',
  // 'Integration',
  // 'Properties',
  // 'UniqueCode'
]
options.group = [{
  text: 'Name',
  value: 'Entity.Name',
  controlType: 'string',
  type: String,
}, 
{
  text: 'Properties',
  value: 'Entity.Properties',
  controlType: 'dictionary~object',
  type: String,
},
]
options.role = [{
  text: 'Name',
  value: 'Entity.Name',
  controlType: 'string',
  type: String,
}, ]

export const propertyOptions = options
